function initIfeedSort(): void {
  const buttons = document.querySelectorAll<HTMLButtonElement>('.ifeed-sort__button');

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const sortField = button.dataset.sortValue;
      const sortDir = button.dataset.sortDir;
      const blockId = button.dataset.sortBlock;

      if (!sortField || !sortDir || !blockId) {
        return;
      }

      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('sort', sortField);
      currentUrl.searchParams.set('sortdir', sortDir);
      currentUrl.hash = blockId;
      window.location.href = currentUrl.toString();
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initIfeedSort);
} else {
  initIfeedSort();
}